var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBellOn({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    fill: "none",
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#474747",
    d: "M6.96 16.868A3.86 3.86 0 0 0 10 18.333c1.238 0 2.34-.574 3.04-1.465a22.6 22.6 0 0 1-6.08 0M15.624 7.5v.587c0 .704.201 1.392.578 1.978l.923 1.436c.843 1.311.2 3.094-1.267 3.508a21.5 21.5 0 0 1-11.716 0c-1.466-.414-2.11-2.197-1.267-3.508l.923-1.436a3.66 3.66 0 0 0 .578-1.978V7.5c0-3.222 2.518-5.833 5.624-5.833s5.624 2.611 5.624 5.833"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBellOn);
export default __webpack_public_path__ + "static/media/bell-on.3ee4d53211ef6a0e917cecefdcc1b78b.svg";
export { ForwardRef as ReactComponent };